import { render, staticRenderFns } from "./notice_edit.vue?vue&type=template&id=97f256d8&scoped=true"
import script from "./notice_edit.vue?vue&type=script&lang=ts"
export * from "./notice_edit.vue?vue&type=script&lang=ts"
import style0 from "./notice_edit.vue?vue&type=style&index=0&id=97f256d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f256d8",
  null
  
)

export default component.exports